import { render, staticRenderFns } from "./Trademarks.vue?vue&type=template&id=7bd13131"
var script = {}
import style0 from "./Trademarks.vue?vue&type=style&index=0&id=7bd13131&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports